
import { defineComponent, computed } from "vue";
import KTTopbar from "@/layout/header/Topbar.vue";
import KTMenu from "@/layout/header/Menu.vue";
import { useStore } from "vuex";
import PartnerSelect from "../PartnerSelect.vue"

import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  components: {
    KTTopbar,
    KTMenu,
    PartnerSelect
  },
  setup() {
    const store = useStore();

    const representPartner = computed(() => store.getters.getRepresentId)


    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      representPartner
    };
  },
});
